<template>
  <div>
    <spinner v-if="loading"></spinner>

    <div class="px-8" v-else>
      <div class="mx-auto">
        <div>
          <h1 class="text-2xl font-bold text-center text-primary">
            ผลการประเมินด้านคุณภาพชีวิต
          </h1>
          <h1 class="text-xl font-light text-center">WHOOQL BREF THAI</h1>
        </div>

        <div class="mt-12 card">
          <h1 class="text-lg font-bold text-center">
            โดยการเกณฑ์การแบ่งระดับคุณภาพชีวิต
            แยกออกเป็นองค์ประกอบต่างๆได้ดังนี้
          </h1>

          <table class="w-full mt-6 shadow-sm">
            <thead>
              <tr>
                <th
                  class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  องค์ประกอบ
                </th>
                <th
                  class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  การมีคุณภาพชีวิตที่ไม่ดี
                </th>
                <th
                  class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  การมีคุณภาพชีวิตกลางๆ
                </th>

                <th
                  class="px-6 py-3 text-sm font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50"
                >
                  การมีคุณภาพชีวิตที่ดี
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="bg-white">
                <td
                  class="px-6 py-4 whitespace``-no-wrap text-sm leading-5 font-medium text-gray-900"
                >
                  ด้านสุขภาพกาย
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  7 - 16
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  17 - 26
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  27 - 35
                </td>
              </tr>
              <tr class="bg-gray-50">
                <td
                  class="px-6 py-4 whitespace``-no-wrap text-sm leading-5 font-medium text-gray-900"
                >
                  ด้านจิตใจ
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  6 - 14
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  15 - 22
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  23 - 30
                </td>
              </tr>
              <tr class="bg-white">
                <td
                  class="px-6 py-4 whitespace``-no-wrap text-sm leading-5 font-medium text-gray-900"
                >
                  ด้านสุขภาพสัมพันธภาพทางสังคม
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  3 - 7
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  8 - 11
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  12 - 15
                </td>
              </tr>
              <tr class="bg-gray-50">
                <td
                  class="px-6 py-4 whitespace``-no-wrap text-sm leading-5 font-medium text-gray-900"
                >
                  ด้านสิ่งแวดล้อม
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  8 - 18
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  19 - 29
                </td>
                <td
                  class="px-6 py-4 text-sm leading-5 text-gray-700 whitespace-no-wrap"
                >
                  30 - 40
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card">
        <h1 class="text-lg font-bold text-center">องค์ประกอบสุขภาพทางกาย</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร
          {{ categorySummary.categories.physicalHealth.numberOfAssessment }} คน
        </p>

        <university-average-sd-stacked-bar-chart
          class="bar-chart"
          :labels="categorySummary.faculties"
          :averages="categorySummary.categories.physicalHealth.groupAverages"
          :universityAverage="
            categorySummary.categories.physicalHealth.categoryAverage
          "
          :yMax="30"
          :sds="
            categorySummary.categories.physicalHealth.groupStandardDeviations
          "
        />
      </div>
      <div class="card">
        <h1 class="text-lg font-bold text-center">องค์ประกอบด้านจิตใจ</h1>

        <div class="flex justify-center">
          <svg
            class="w-4 h-4 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
            ></path>
          </svg>
          <p class="mb-2 text-xs text-center">
            จากบุคลากร
            {{ categorySummary.categories.mentalHealth.numberOfAssessment }} คน
          </p>
        </div>

        <university-average-sd-stacked-bar-chart
          class="bar-chart"
          :labels="categorySummary.faculties"
          :averages="categorySummary.categories.mentalHealth.groupAverages"
          :universityAverage="
            categorySummary.categories.mentalHealth.categoryAverage
          "
          :yMax="25"
          :sds="categorySummary.categories.mentalHealth.groupStandardDeviations"
        />
      </div>
      <div class="card">
        <h1 class="text-lg font-bold text-center">
          องค์ประกอบด้านสัมพันธภาพทางสังคม
        </h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร
          {{ categorySummary.categories.social.numberOfAssessment }} คน
        </p>

        <university-average-sd-stacked-bar-chart
          class="bar-chart"
          :labels="categorySummary.faculties"
          :averages="categorySummary.categories.social.groupAverages"
          :universityAverage="categorySummary.categories.social.categoryAverage"
          :sds="categorySummary.categories.social.groupStandardDeviations"
          :yMax="15"
        />
      </div>
      <div class="card">
        <h1 class="text-lg font-bold text-center">ด้านสิ่งแวดล้อม</h1>
        <p class="mb-2 text-xs text-center">
          จากบุคลากร
          {{ categorySummary.categories.environment.numberOfAssessment }} คน
        </p>

        <university-average-sd-stacked-bar-chart
          class="bar-chart"
          :labels="categorySummary.faculties"
          :averages="categorySummary.categories.environment.groupAverages"
          :universityAverage="
            categorySummary.categories.environment.categoryAverage
          "
          :sds="categorySummary.categories.environment.groupStandardDeviations"
          :yMax="35"
        />
      </div>
    </div>
  </div>
</template>

<script>
import UniversityAverageSdStackedBarChart from "./charts/UniversityAverageSdStackedBarChart";
import axios from "axios";
import Spinner from "@/components/loading/Spinner";
import EventBus from "@/events/event-bus.js";

export default {
  name: "hplp-dashboard",
  components: {
    UniversityAverageSdStackedBarChart,
    Spinner,
  },
  created() {
    this.fetchCategory();

    EventBus.$on("dashboardYearChanged", this.fetchCategory);
    EventBus.$on("dashboardEmployeeTypeChanged", this.fetchCategory);
  },
  beforeDestroy() {
    EventBus.$off("dashboardYearChanged", this.fetchCategory);
    EventBus.$off("dashboardEmployeeTypeChanged", this.fetchCategory);
  },
  data() {
    return {
      categorySummary: {},
      loading: true,
    };
  },
  methods: {
    async fetchCategory() {
      this.loading = true;

      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/dashboard/whoqol/category?year=${this.$store.state.dashboardYear}&employeeType=${this.$store.state.dashboardEmployeeType}`,
          // headers: { authorization: `Bearer ${localStorage.getItem("TOKEN")}` }
        });

        this.categorySummary = response.data;

        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style src="vue-slim-tabs/themes/default.css"></style>
